//IMPORTANTE: No pueden haber codes duplicados entre sí. Idem para values
const characteristicTranslate: Record<string, string> = {
  'CHARACTERISTICS.VEHICLE.COMFORT.AC': 'Aire Acondicionado',
  'CHARACTERISTICS.VEHICLE.COMFORT.POWER_WINDOW': 'Alzavidrios Eléctricos',
  'CHARACTERISTICS.VEHICLE.COMFORT.POWER_LOCKS': 'Cierre Centralizado',
  'CHARACTERISTICS.VEHICLE.COMFORT.CRUISE_CONTROL': 'Control Crucero',
  'CHARACTERISTICS.VEHICLE.COMFORT.ALL_WHEEL_DRIVE': 'Tracción Integral (4x4/4WD/AWD/IWD)',
  'CHARACTERISTICS.VEHICLE.COMFORT.ADJUSTABLE_STEERING_WHEEL': 'Volante Ajustable',
  'CHARACTERISTICS.VEHICLE.COMFORT.CD_CHANGER': 'Caja para CD',
  'CHARACTERISTICS.VEHICLE.COMFORT.CD_RECEIVER': 'Radio con CD',
  'CHARACTERISTICS.VEHICLE.COMFORT.MP3_RECEIVER': 'Radio con MP3',
  'CHARACTERISTICS.VEHICLE.COMFORT.AM_FM_RECEIVER': 'Radio AM/FM',
  'CHARACTERISTICS.VEHICLE.COMFORT.ON_BOARD_COMPUTER': 'Computador a Bordo',
  'CHARACTERISTICS.VEHICLE.COMFORT.HEATED_SEATS': 'Asientos Calefaccionados',
  'CHARACTERISTICS.VEHICLE.COMFORT.POWER_SEATS': 'Asientos Eléctricos',
  'CHARACTERISTICS.VEHICLE.COMFORT.MEMORY_SEATS': 'Asientos con Memoria',
  'CHARACTERISTICS.VEHICLE.COMFORT.LEATHER_SEATS': 'Asientos de Cuero',
  'CHARACTERISTICS.VEHICLE.EXTERIOR.POWER_MIRRORS': 'Espejos Eléctricos',
  'CHARACTERISTICS.VEHICLE.EXTERIOR.ALLOY_AHEELS': 'Llantas de Aleación', // Note: there's a typo in the key 'ALLOY_AHEELS'
  'CHARACTERISTICS.VEHICLE.EXTERIOR.FRONT_FOG_LIGHTS': 'Neblineros Delanteros',
  'CHARACTERISTICS.VEHICLE.EXTERIOR.REAR_FOG_LIGHTS': 'Neblineros Traseros',
  'CHARACTERISTICS.VEHICLE.EXTERIOR.POWER_ROOF': 'Techo Eléctrico',
  'CHARACTERISTICS.VEHICLE.EXTERIOR.MANUAL_ROOF': 'Techo Manual',
  'CHARACTERISTICS.VEHICLE.EXTERIOR.REAR_WINDOW_WIPERS': 'Limpiavidrio Trasero',
  'CHARACTERISTICS.VEHICLE.EXTERIOR.TINTED_WINDOWS': 'Vidrios Polarizados',
  'CHARACTERISTICS.VEHICLE.EXTERIOR.XENON_LIGHTS': 'Luces de Xenon',
  'CHARACTERISTICS.VEHICLE.SECURITY.ALARM': 'Alarma',
  'CHARACTERISTICS.VEHICLE.SECURITY.DRIVER_AIRBAG': 'Airbag Conductor',
  'CHARACTERISTICS.VEHICLE.SECURITY.COPILOT_AIRBAG': 'Airbag Copiloto',
  'CHARACTERISTICS.VEHICLE.SECURITY.LATERAL_AIRBAG': 'Airbags Laterales',
  'CHARACTERISTICS.VEHICLE.SECURITY.ABS': 'Frenos Anti-bloqueo (ABS)',
  'CHARACTERISTICS.VEHICLE.SECURITY.EBD': 'Distribución de Frenado Electrónica (EBD/EBFD/EBL)',
  'CHARACTERISTICS.VEHICLE.SECURITY.ESP': 'Control de Estabilización Electrónica (ESC/ESP/DSC)',
  'CHARACTERISTICS.VEHICLE.SECURITY.TCS': 'Control de Tracción (TCS/ASR)',
  'CHARACTERISTICS.VEHICLE.SECURITY.REAR_HEADREST': 'Apoya Cabeza Trasero',
  'CHARACTERISTICS.VEHICLE.SECURITY.REAR_DISC_BRAKES': 'Frenos de Disco Traseros',
  'CHARACTERISTICS.VEHICLE.SECURITY.CHIP_KEY': 'Llave Electrónica (Chip/Inteligente)',
  'CHARACTERISTICS.VEHICLE.SECURITY.LOCKING_WHEEL_NUT': 'Tuerca de Seguridad',
  'CHARACTERISTICS.VEHICLE.SECURITY.RAIN_SENSOR': 'Sensor de Lluvia',
}

export const invertedCharacteristics: Record<string, string> = Object.entries(characteristicTranslate).reduce(
  (acc, [key, value]) => {
    acc[value] = key

    return acc
  },
  {} as Record<string, string>
)

export default characteristicTranslate
